/**
 * 파일명 : com0103p.jsx
 * 설명 : 수신자선택
 * 수정내역
 ************************************************
 * Version    수정일자      수정자    수정내용      
 ************************************************
 */


/************************************************
 * Import 영역
 ************************************************/
/* React */
import React from 'react';

/* CSS */
import 'index.css';

/* AntD */
import { Layout, Row, Col, Space, Button, Table } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

/* 업무 */
import * as commonProxy from 'libs/CommonProxy';

/* Reducer */
import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import { Com0103pAction } from '../../../redux/slice/com/com0103p_slice';

/************************************************
 * 전역변수 선언영억
 ************************************************/


const Com0103p = (props:any) => {
    /* State / Reducer */
    const dispatch = useAppDispatch();
    const allUserList        = useAppSelector((state) => state.Com0103p.allUserList);
    const recipientList      = useAppSelector((state) => state.Com0103p.recipientList);
    const selectedUsrRowKeys = useAppSelector((state) => state.Com0103p.selectedUsrRowKeys);

    /**
     * 기능 : componentDidMount
     * 설명 : 화면 최초 로드시에 필요한 기능을 구현한다.
     * param : 
     * return : None
     **/
     React.useEffect(() => {
        /* 변수선언 및 셋팅 영역 */
        const requestData = {
            includeAdmin : 'N',
            userStCd : 'A',
            boardDcd : props.boardDcd ? props.boardDcd : ''
        };

        /* 트렌젝션 호출 및 결과 셋팅 */
        commonProxy.callAsyncSvc(requestData, {
            txCd : 'TRUSRR0003',
            success: (responseData:any) => {
                dispatch(Com0103pAction.setAllUserList(responseData.userList));
                dispatch(Com0103pAction.setRecipientList(props.dataList ? props.dataList : []));
            },
        });
    }, [props.boardDcd, props.dataList]);


    /************************************************
     * 이벤트 함수 영역
     ************************************************/
    /**
     * 기능 : onClick 이벤트 선언
     * param : 
     */
    const onClick = (e:any) => {
        const buttonName = e.currentTarget.name;
        switch (buttonName) {
            case 'btnClose': {
                props.cancel();
                break;
            }
            case 'btnOk': {
                props.accept(recipientList);
                break;
            }
            default:
        }
    };

    /************************************************
     * 개발자함수 영역
     ************************************************/
    

    /************************************************
     * Render 변수 선언 및 셋팅영역
     ************************************************/


     /* Render 변수 선언영역 */
     /* AntD */
     const { Content } = Layout;

    /* Table Columns */
    const columnsAllUsers = React.useCallback(() => {
        const arr:any = [
            {
                title: () => <div style={{ textAlign: 'center' }}>부서</div>,
                dataIndex: 'deptNm',
                key: 'deptNm',
                align: 'center',
                width: '40%',
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>직위</div>,
                dataIndex: 'postNm',
                key: 'postNm',
                align: 'center',
                width: '30%',
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>이름</div>,
                dataIndex: 'userNm',
                key: 'userNm',
                align: 'center',
                width: '25%',
            },
        ]
        return arr;
    }, []);

    const columnsRecipient = React.useCallback(() => {
        const arr:any = [
            {
                title: () => <div style={{ textAlign: 'center' }}>부서</div>,
                dataIndex: 'deptNm',
                key: 'deptNm',
                align: 'center',
                width: '40%',
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>직위</div>,
                dataIndex: 'postNm',
                key: 'postNm',
                align: 'center',
                width: '30%',
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>이름</div>,
                dataIndex: 'userNm',
                key: 'userNm',
                align: 'center',
                width: '25%',
            },
        ]
        return arr;
    }, []);

    const allUserRowSelection = {
        selectedRowKeys: selectedUsrRowKeys,
        onChange: (selectedRowKeys:any) => {
          dispatch(Com0103pAction.setSelectedUsrRowKeys(selectedRowKeys));
        },
    };
    const recipientRowSelection = {
        onChange: (selectedRowKeys:any) => {
          dispatch(Com0103pAction.setSelectedRecRowKeys(selectedRowKeys));
        },
    };


    return (
        /* 화면 디자인 영역*/
        <Layout>
            <Content>
                <Row>
                    <Space size='small'>
                        <Col>
                            <Table 
                                columns={columnsAllUsers()}
                                dataSource={allUserList}
                                size='small'
                                rowKey='empNo'
                                pagination={false}
                                style={{width:600, height: 400}}
                                scroll={{y:300}}
                                rowSelection={{
                                    type: 'checkbox',
                                    ...allUserRowSelection,
                                }}
                            />
                        </Col>
                        <Col>
                            <Space size='small' direction='vertical'>
                                <Button 
                                    size='small'
                                    name='btnRecipient'
                                    className='background-color-default-button' 
                                    onClick={() => {
                                        let selectedUsers = recipientList.map(item => item.empNo);
                                        const selectedUsrList = allUserList.filter(data => {
                                            return selectedUsrRowKeys.includes(data.empNo) && !selectedUsers.includes(data.empNo);
                                        });

                                        for(let i = 0; i < selectedUsrList.length; i++){
                                            dispatch(Com0103pAction.addRecipientList(selectedUsrList[i]));
                                        }
                                        dispatch(Com0103pAction.setSelectedUsrRowKeys([]));
                                    }}
                                    icon={<RightOutlined/>}>넣기
                                </Button>
                                <Button 
                                    size='small'
                                    name='btnRecipient'
                                    className='background-color-default-button'
                                    onClick={() => {dispatch(Com0103pAction.removeRecipientList())}}
                                    icon={<LeftOutlined/>}>빼기
                                </Button>
                            </Space>
                        </Col>
                        <Col>
                            <Table 
                                columns={columnsRecipient()}
                                dataSource={recipientList}
                                size='small'
                                rowKey='empNo'
                                pagination={false}
                                style={{width:600, height: 400}}
                                scroll={{y:300}}
                                rowSelection={{
                                    type: 'checkbox',
                                    ...recipientRowSelection,
                                }}
                            />
                        </Col>
                    </Space>
                </Row>
                <Row style={{ display: "flex", justifyContent: "center", alignItems: "center", height : '80%' }}>
                    <Col>
                        <Space direction='vertical'>
                            <Row justify='space-around' style={{ marginTop: 20 }}>
                                <Space size='small'>
                                    <Button
                                        name='btnClose'
                                        className='background-color-default-button'
                                        onClick={onClick}
                                    >
                                        닫기
                                    </Button>
                                    <Button
                                        name='btnOk'
                                        className='background-color-primary-button'
                                        onClick={onClick}
                                    >
                                        확인
                                    </Button>
                                </Space>
                            </Row>
                        </Space>
                    </Col>
                </Row>
            </Content>
        </Layout>
    );
}

export default Com0103p;